import { useEffect, useRef, useState } from 'react';
import cls from './Game.module.scss';
import shipImage from '../../shared/assets/images/ship-1.svg';
import gameBg1 from '../../shared/assets/images/game-bg-1.webp';
import leftSrc from '../../shared/assets/images/left.svg';
import rightSrc from '../../shared/assets/images/right.svg';
import pauseSrc from '../../shared/assets/images/pause-button.svg';
import { useSpring, animated } from '@react-spring/web';
import {
  Background,
  Player,
  Trajectory,
  isSegmentIntersectingPolygon,
  trajectoryCoordinates,
} from './game_assets';
import { setIsPause, userDead, userWon } from '../../shared/redux/game/slice';
import { useDispatch, useSelector } from 'react-redux';
import { Dead } from '../../shared/redux/game/types';
import { setPage } from '../../shared/redux/page/slice';
import { Pages } from '../../shared/redux/page/types';
import GiveUpSrc from '../../shared/assets/images/give-up-button.svg';
import ContinueSrc from '../../shared/assets/images/continue-button.svg';
import { sounds } from '../../shared/ui/Sound/assets';
import { RootState } from '../../shared/redux/store';
import { positionType } from './Level2';

// Загрузка изображения корабля
const shipImg = new Image();
shipImg.src = shipImage;
shipImg.width = 20;
shipImg.height = 104;

// Загрузка фонового изображения
const backgroundImage = new Image();
backgroundImage.src = gameBg1;
backgroundImage.width = 1248;
backgroundImage.height = 2106;

const getRoundedNumber = (num: number) => {
  let rounded = num.toFixed(2); // "123.46" в виде строки
  return parseFloat(rounded);
};
export const Level1 = () => {
  const windowApp = document.getElementById('app-window');
  const windowWidth = windowApp ? windowApp.offsetWidth : 375;
  const windowHeight = windowApp ? windowApp.offsetHeight : 667;
  const wonTimeoutId = useRef<null | ReturnType<typeof setTimeout>>(null);
  console.log(windowWidth, windowHeight);
  const [springPropsContainer, setSpringPropsContainer] = useSpring(() => ({
    transform: `translate3D(${-backgroundImage.width / 2 + windowWidth / 2}px, 0px, 0px)`,
    config: { tension: 350, friction: 30 },
  }));
  const [springPropsShip, setSpringPropsShip] = useSpring(() => ({
    transform: `translate3D(${windowWidth / 2 + 30}px, ${
      windowHeight - 250 - 52
    }px, 0px) rotate(0rad)`,
    config: { tension: 350, friction: 30 },
  }));
  const dispatch = useDispatch();
  const isSound = useSelector((state: RootState) => state.page.isSound);
  const isPausePressed = useSelector((state: RootState) => state.game.isPause);

  const canvasRef = useRef<HTMLCanvasElement | null>(null);
  const ctxRef = useRef<CanvasRenderingContext2D | null>(null);
  const playerRef = useRef<Player>(new Player(windowWidth / 2 + 40, windowHeight - 250, shipImg));

  const trajectoryRef = useRef<Trajectory>(
    new Trajectory(trajectoryCoordinates, windowWidth, windowHeight),
  );
  const pauseRef = useRef<HTMLImageElement | null>(null);

  const scrollOffset = useRef({
    x: 0,
    y: 1,
  });

  const scrollOffsetBgRef = useRef<positionType>({
    x: -backgroundImage.width / 2 + windowWidth / 2,
    y: 0,
  });

  const leftRef = useRef<HTMLImageElement | null>(null);
  const rightRef = useRef<HTMLImageElement | null>(null);
  const leftKeyPressed = useRef<boolean>(false);
  const rightKeyPressed = useRef<boolean>(false);
  const isPause = useRef(false);
  const isFirstLoaded = useRef<boolean>(true);
  const animationId = useRef<number | null>(null);

  const animate = () => {
    const ctx = ctxRef.current;
    animationId.current = requestAnimationFrame(animate);

    if (isPause.current) {
      cancelAnimationFrame(animationId.current);
    }

    scrollOffset.current.x += Math.sin(playerRef.current.angle);

    if (
      isSegmentIntersectingPolygon(
        playerRef.current.headPosition,
        playerRef.current.assPosition,
        trajectoryRef.current.currentPoints,
      )
    ) {
      if (isSound) {
        sounds.collision.play();
      }
      cancelAnimationFrame(animationId.current);
      dispatch(userDead(Dead.ICE));
      dispatch(setPage(Pages.PREFINAL));
    }
    setSpringPropsContainer({
      transform: `translate3D(${scrollOffsetBgRef.current.x}px, ${scrollOffsetBgRef.current.y}px, 0px)`,
    });
    setSpringPropsShip({
      transform: `translate3D(${playerRef.current.position.x - 10}px, ${
        playerRef.current.position.y - 52
      }px, 0px) rotate(${playerRef.current.angle}rad)`,
    });

    if (ctx) {
      // ctx.fillStyle = '#e6fafe';
      // ctx.fillRect(0, 0, windowWidth, windowHeight);

      // backgroundRef.current.draw(ctx);
      trajectoryRef.current.update(ctx);
      playerRef.current.update(ctx);
    }

    if (leftKeyPressed.current) {
      playerRef.current.angle -= 0.01;
    } else if (rightKeyPressed.current) {
      playerRef.current.angle += 0.01;
    }

    scrollOffset.current.x += Math.sin(playerRef.current.angle);
    scrollOffset.current.y += Math.cos(playerRef.current.angle);
    //change velocity
    if (playerRef.current.position.y > windowHeight / 2) {
      playerRef.current.velocity.x = Math.sin(playerRef.current.angle) * 0.5;
      playerRef.current.velocity.y = -Math.cos(playerRef.current.angle) * 0.5;
    } else {
      playerRef.current.velocity.y = 0;
      playerRef.current.velocity.x = 0;

      //Проверка победы
      if (scrollOffset.current.y < 2700) {
        scrollOffsetBgRef.current.x -= Math.sin(playerRef.current.angle) * 0.5;
        scrollOffsetBgRef.current.y += Math.cos(playerRef.current.angle) * 0.5;

        trajectoryRef.current.position.x += getRoundedNumber(
          -Math.sin(playerRef.current.angle) * 0.5,
        );
        trajectoryRef.current.position.y += Math.cos(playerRef.current.angle) * 0.5;
      } else {
        cancelAnimationFrame(animationId.current);
        if (isSound) {
          sounds.ship1.play();
        }
        wonTimeoutId.current = setTimeout(() => {
          dispatch(userWon());
        }, 2000);
      }
    }
  };

  const handleKeyPress = (e: KeyboardEvent) => {
    if (e.key === 'ArrowLeft') {
      leftKeyPressed.current = true;
    } else if (e.key === 'ArrowRight') {
      rightKeyPressed.current = true;
    }
  };
  const handleKeyRelease = () => {
    leftKeyPressed.current = false;
    rightKeyPressed.current = false;
  };

  useEffect(() => {
    if (isPausePressed) {
      isPause.current = true;
    } else if (!isFirstLoaded.current) {
      isPause.current = false;
      animate();
      console.log('animate, isPausePressed: ', isPausePressed);
    }
  }, [isPausePressed]);

  useEffect(() => {
    if (canvasRef.current && isFirstLoaded.current) {
      const canvas = canvasRef.current;
      // canvas.style.imageRendering = 'pixelated';
      const ctx = canvas ? canvas.getContext('2d') : null;
      ctxRef.current = ctx;

      leftRef.current?.addEventListener('mousedown', () => {
        leftKeyPressed.current = true;
      });
      leftRef.current?.addEventListener('mouseup', () => {
        leftKeyPressed.current = false;
      });
      rightRef.current?.addEventListener('mousedown', () => {
        rightKeyPressed.current = true;
      });
      rightRef.current?.addEventListener('mouseup', () => {
        rightKeyPressed.current = false;
      });

      window.addEventListener('keydown', handleKeyPress);
      window.addEventListener('keyup', handleKeyRelease);
      leftRef.current?.addEventListener('touchstart', function (event) {
        event.preventDefault();
        leftKeyPressed.current = true;
      });
      leftRef.current?.addEventListener('touchend', function (event) {
        event.preventDefault();
        leftKeyPressed.current = false;
      });
      rightRef.current?.addEventListener('touchstart', function (event) {
        event.preventDefault();
        rightKeyPressed.current = true;
      });
      rightRef.current?.addEventListener('touchend', function (event) {
        event.preventDefault();
        rightKeyPressed.current = false;
      });
    }
    isFirstLoaded.current = false;
    animate();
    return () => {
      window.removeEventListener('keydown', handleKeyPress);
      window.removeEventListener('keyup', handleKeyRelease);
      if (wonTimeoutId.current) {
        clearTimeout(wonTimeoutId.current);
      }
    };
  }, []);

  return (
    <div className={`${cls.Game} page-container`}>
      <animated.img
        src={gameBg1}
        className={cls.BackgroundImage}
        style={{ ...springPropsContainer }}
      />
      <canvas ref={canvasRef} width={windowWidth} height={windowHeight} />
      <animated.img src={shipImage} className={cls.shipImage} style={{ ...springPropsShip }} />
      <div className={cls.buttons}>
        <img
          className={cls.button}
          alt="Left"
          src={leftSrc}
          ref={leftRef}
          onContextMenu={() => false}
        />
        <img
          className={cls.button}
          alt="Right"
          src={rightSrc}
          ref={rightRef}
          onContextMenu={() => false}
        />
      </div>

      {isPausePressed ? (
        <div className={cls.PausePageContainer}>
          <div className="text-container" style={{ top: '18%' }}>
            <h1 className="text-bg-h1">ПАУЗА</h1>
            <h1>ПАУЗА</h1>
          </div>
          <img
            alt="Give Up"
            src={GiveUpSrc}
            className={cls.GiveUp}
            onClick={() => {
              if (isSound) {
                sounds.btn.play();
              }
              dispatch(userDead(Dead.NONE));
              dispatch(setPage(Pages.FINAL));
              dispatch(setIsPause(false));
            }}
          />
          <img
            alt="Continue"
            src={ContinueSrc}
            className={cls.Continue}
            onClick={() => {
              if (isSound) {
                sounds.btn.play();
              }
              dispatch(setIsPause(false));
            }}
          />
        </div>
      ) : (
        <img
          className={cls.pauseImg}
          src={pauseSrc}
          alt="pause"
          ref={pauseRef}
          onClick={() => {
            if (isSound) {
              sounds.btn.play();
            }
            dispatch(setIsPause(true));
          }}
        />
      )}
    </div>
  );
};
